<template>
  <Form
    class="form-block-popup"
    :error="error"
    :error-text="error"
    @submit="submit"
  >
    <div class="top-window mb8">
      <div class="heading1 heading1-line">Отправка результата работы</div>
    </div>
    <div class="text-secondary">Загрузите итоговые файлы заказчику</div>
    <UploadModels
      :files="files"
      is-lab
      @change="data => files = data"
      @load="filesLoading => loading = filesLoading"
      @error="error = $event"
    />

    <Submit
      usual
      small
      text="Завершить заказ"
    />
  </Form>
</template>

<script>
  import Form from '@/components/Form';
  import UploadModels from '@/containers/new-order/UploadModels';
  import Submit from '@/components/Submit';
  import parseError from '@/utils/api/parse-error';
  import factory from '@/utils/api/factory';
  import {mapActions} from 'vuex';

  export default {
    name: 'EndOrder',
    components: {
      Submit,
      UploadModels,
      Form,
    },
    props: {
      context: {
        type: Object,
        default: () => ({
          id: null,
        }),
      },
    },
    data () {
      return {
        error: null,
        isLoading: false,
        loading: false,
        files: [],
      };
    },
    methods: {
      ...mapActions({
        close: 'modal/closeModal',
        reload: 'global/changeAction',
      }),
      async submit () {
        this.error = null;

        if (this.loading) {
          this.error = 'Подождите, пока файлы загрузятся.';
          return;
        } else if (!this.files.length) {
          this.error = 'Загрузите хотя бы один файл.';
          return;
        }

        try {
          await factory(`laboratory/orders/${this.context.id}/complete`).customPost({
            lab_scans: this.files.map(file => file.id),
          });
          await this.reload('reloadOrders');
          this.close();
        } catch (e) {
          this.error = parseError(e) || 'Что-то пошло не так.';
        }
      },
    },
  };
</script>

<style lang="scss">
  .popup-close-application {
    .form-block {
      margin-bottom: 0;
    }

    .btn-wrap {
      float: unset;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      input[type=submit] {
        width: 200px;
      }
      @media screen and (max-width: 480px) {
        input[type=submit] {
          width: 100%;
        }
      }
    }
  }
</style>
